var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCostSaving = function SvgCostSaving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#cost-saving_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 26.75c0 .97.75 1.75 1.67 1.75h1.88c.8 0 1.45-.68 1.45-1.53 0-.91-.4-1.24-.99-1.45L24 24.47c-.59-.21-.99-.53-.99-1.45 0-.84.65-1.53 1.45-1.53h1.88c.92 0 1.67.78 1.67 1.75M25.5 20.5v9M30.5 16v4h4M35.5 15l-5 5",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 15c-5.52 0-10 4.48-10 10 0 3.94 2.28 7.35 5.6 8.98M35.5 25c0 5.52-4.48 10-10 10",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cost-saving_svg__a",
    x1: 25.5,
    y1: 0,
    x2: 25.5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C68F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#4C68F6",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C68F6",
    stopOpacity: 0.49
  })))));
};

export default SvgCostSaving;